var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.995 511.995",
    style: {
      enableBackground: "new 0 0 511.995 511.995"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    fill: "#CEA57E",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M98.102,6.525c-13.19-7.94-28.91-8.65-42.62-2.04l229.87,230.36l75.16-75.51L98.102,6.525z M34.362,25.805   c-2.9,6.14-4.46,12.97-4.46,20v421.38c0,7.06,1.57,13.79,4.5,19.8l229.78-230.87L34.362,25.805z M285.383,277.355l-229.5,230.59   c6.09,2.82,12.57,4.05,19.04,4.05c7.99,0,15.96-1.91,23.18-6.25l262.46-153.04L285.383,277.355z M460.453,217.535   c-0.09-0.06-0.19-0.12-0.28-0.17l-72.86-42.43l-80.77,81.15l80.82,80.99c0,0,73-42.56,73.09-42.61   c13.55-8.23,21.64-22.61,21.64-38.47S474.003,225.755,460.453,217.535z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google_play.86f22cd89c805a692be42d6d15c2ab5b.svg";
export { ForwardRef as ReactComponent };